import App from "../../app";
import { FilterValue } from "../../lib/filter";
import { ListItem } from "../../model/datasource/list";
import { ContentItem } from "../../model/datasource/item";
import { SettingsFrontend } from "../frontend";
import {
	AttemptId, ProductId, ItemId, QuizId
} from "../../model/datasource";

export abstract class SettingsView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	frontend: SettingsFrontend<I>;

	constructor(frontend?: SettingsFrontend<I>) {
		this.frontend = frontend;
	}

	abstract init(app: App<P, A, Z, I>): void

	abstract displayFontSize(size: number): void
	abstract displayKeyboardShortcuts(enabled: boolean): void
	abstract displayTimer(show: boolean): void
	abstract toggleShortcutModal(jQuery: JQueryStatic): void
	abstract displayErrorLoading(show: boolean): void
	abstract displayErrorModal(jQuery: JQueryStatic, url: string, item: ContentItem<I> | ListItem<I>, filters: FilterValue[], screenshot: string, errors: (Error | any)[], localStorage: Record<string, any>): void
	abstract hideErrorModal(jQuery: JQueryStatic, success: boolean, reason?: string)
	abstract displayInputSuggestion(element: HTMLElement, suggestion: string | undefined): void
	abstract updateInputs(root: HTMLElement, selector: string, value: string): HTMLInputElement[]
	abstract displayReportErrorMessage(message: string): void
	abstract displayAdvance(enable: boolean): void
	abstract displayAdvanceInterval(interval: number): void
	abstract displayTimed(enable: boolean): void
}

export class NullSettingsView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> implements SettingsView<P, A, Z, I> {
	frontend: SettingsFrontend<I>;

	init(app: App<P, A, Z, I>): void { }

	displayFontSize(size: number): void {
		throw new Error("Method not implemented.");
	}

	displayKeyboardShortcuts(enabled: boolean): void {
		throw new Error("Method not implemented.");
	}

	displayTimer(show: boolean): void {
		throw new Error("Method not implemented.");
	}

	toggleShortcutModal(jQuery: JQueryStatic): void {
		throw new Error("Method not implemented.");
	}

	displayErrorLoading(show: boolean): void {
		throw new Error("Method not implemented.");
	}

	displayErrorModal(jQuery: JQueryStatic, url: string, item: ContentItem<I> | ListItem<I>, filters: FilterValue[], screenshot: string, errors: (Error | any)[], localStorage: Record<string, any>): void {
		throw new Error("Method not implemented.");
	}

	hideErrorModal(jQuery: JQueryStatic, success: boolean, reason?: string): void {
		throw new Error("Method not implemented.");
	}

	displayInputSuggestion(element: HTMLElement, suggestion: string | undefined): void {
		throw new Error("Method not implemented.");
	}

	updateInputs(root: HTMLElement, selector: string, value: string): HTMLInputElement[] {
		throw new Error("Method not implemented");
	}

	displayReportErrorMessage(message: string): void {
		throw new Error("Method not implemented.");
	}

	displayAdvance(enable: boolean): void {
		throw new Error("Method not implemented.");
	}

	displayAdvanceInterval(interval: number): void {
		throw new Error("Method not implemented.");
	}

	displayTimed(enable: boolean): void {
		throw new Error("Method not implemented.");
	}
}

